module.exports = __webpack_public_path__ + "static/media/Geared Slab-01.c2e28567.svg";